import React, { useState } from "react";

import UpdatedCasesList from "../../../components/cases/UpdatedCasesList";

import { useOutletContext } from "react-router-dom";

const UpdatedCases = () => {
  const [refresh, setRefresh] = useState(false);
  const [
    data,
    handleRefreh,
    location,
    search,
    handleSearch,
    searchFilterState,
    handleFilterStateActive,
    entireCasesText,
    handleEntireCasesText,
    handleSetConsultantFilter,
    selectedConsultant,
    consultantsList,
    selectedConsultantName,
  ] = useOutletContext();
  const handleRefreshByParent = () => {
    setRefresh((pre) => !pre);
    handleRefreh();
  };
  return (
    <UpdatedCasesList
      data={data}
      handleRefresh={handleRefreshByParent}
      search={search}
      handleSearch={handleSearch}
      searchFilterState={searchFilterState}
      handleEntireCasesText={handleEntireCasesText}
      entireCasesText={entireCasesText}
      handleFilterStateActive={handleFilterStateActive}
      handleSetConsultantFilter={handleSetConsultantFilter}
      selectedConsultant={selectedConsultant}
      consultantsList={consultantsList}
      selectedConsultantName={selectedConsultantName}
    />
  );
};

export default UpdatedCases;
